// RunFree product page — behaviour ported from runfree-site/סקשן-מוצר/סקשן-מוצר.html.
// Every section script runs once per root element (the file is included by several sections).
(function () {
  if (window.__rfPdp) return;
  window.__rfPdp = true;

  // drag a horizontal track with the mouse on desktop (fingers scroll natively)
  function mouseDrag(track, onEnd) {
    let down = null;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      down = { x: e.clientX, left: track.scrollLeft };
      track.style.scrollSnapType = 'none';
    });
    window.addEventListener('pointermove', (e) => { if (down) track.scrollLeft = down.left - (e.clientX - down.x); });
    window.addEventListener('pointerup', (e) => {
      if (!down) return;
      const dx = e.clientX - down.x; down = null;
      if (onEnd) onEnd(dx); else track.style.scrollSnapType = '';
    });
    track.addEventListener('dragstart', (e) => e.preventDefault());
  }

  // eased scroll to a position: identical in every browser, also right-to-left
  function scrollToX(track, to, dur, state) {
    const from = track.scrollLeft, t0 = performance.now();
    if (state.anim) cancelAnimationFrame(state.anim);
    track.style.scrollSnapType = 'none';
    const step = (now) => {
      const k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      track.scrollLeft = from + (to - from) * e;
      if (k < 1) state.anim = requestAnimationFrame(step); else { state.anim = null; track.style.scrollSnapType = ''; }
    };
    state.anim = requestAnimationFrame(step);
    // fallback when frames don't paint (background tab)
    clearTimeout(state.t);
    state.t = setTimeout(() => { if (state.anim) { cancelAnimationFrame(state.anim); state.anim = null; } track.scrollLeft = to; track.style.scrollSnapType = ''; }, dur + 80);
  }

  // ===== product: gallery, colour, bundle, add to cart =====
  function initProduct(root) {
    const track = root.querySelector('[data-track]');
    const slides = [...track.children];
    const thumbsBox = root.querySelector('[data-thumbs]');
    const thumbs = thumbsBox ? [...thumbsBox.children] : [];
    const gstate = {};
    let current = 0;

    function setActive(i) {
      if (!thumbs.length || thumbs[i].classList.contains('is-active')) return;
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      const t = thumbs[i];
      const target = t.offsetLeft - thumbsBox.offsetLeft - (thumbsBox.clientWidth - t.offsetWidth) / 2;
      thumbsBox.scrollTo({ left: target, behavior: 'smooth' });
      clearTimeout(setActive.t); setActive.t = setTimeout(() => { thumbsBox.scrollLeft = target; }, 450);
    }
    function go(i) {
      current = Math.max(0, Math.min(slides.length - 1, i));
      setActive(current);
      scrollToX(track, slides[current].offsetLeft - track.offsetLeft, 320, gstate);
    }
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    root.querySelector('[data-next]')?.addEventListener('click', () => go(current + 1));
    root.querySelector('[data-prev]')?.addEventListener('click', () => go(current - 1));
    track.addEventListener('scroll', () => {
      const i = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
      if (!gstate.anim) current = i;
      setActive(Math.max(0, Math.min(slides.length - 1, i)));
    }, { passive: true });
    // a gallery video plays muted + looped only while its slide is on screen
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      const v = e.target.querySelector('video'); if (!v) return;
      if (e.isIntersecting) { v.muted = true; v.play().catch(() => {}); } else v.pause();
    }), { root: track, threshold: 0.6 });
    slides.forEach((s) => io.observe(s));
    // RTL: dragging right = next image (like a finger swipe)
    mouseDrag(track, (dx) => { if (Math.abs(dx) > 40) go(current + (dx > 0 ? 1 : -1)); else go(current); });

    // colour: changes only the first gallery image (blue / pink)
    const mainImg = slides[0].querySelector('img');
    const mainThumb = thumbs[0]?.querySelector('img');
    root.querySelectorAll('.swatch').forEach((s) => s.addEventListener('click', () => {
      root.querySelectorAll('.swatch').forEach((x) => x.classList.remove('is-active'));
      s.classList.add('is-active');
      root.querySelector('[data-color-name]').textContent = s.dataset.name;
      if (mainImg && s.dataset.img) { mainImg.srcset = s.dataset.srcset; mainImg.src = s.dataset.img; }
      if (mainThumb && s.dataset.thumb) { mainThumb.removeAttribute('srcset'); mainThumb.src = s.dataset.thumb; }
      go(0);
    }));

    // ----- bundle -----
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    const states = [
      { fill: 0.1667, msg: 'אתם במרחק זוג נוסף מ<strong>זוג שלישי חינם</strong>', on: 1, done: false },
      { fill: 0.5, msg: 'קיבלתם <strong>זוג חינם</strong>! עוד אחד ו<strong>החמישי חינם</strong>', on: 2, done: false },
      { fill: 1, msg: 'כל הכבוד! קיבלתם <strong>2 זוגות חינם</strong>, הרווחתם!', on: 3, done: true },
    ];
    const tier = root.querySelector('[data-tier]');
    const atc = root.querySelector('[data-atc]');
    const err = root.querySelector('[data-atc-err]');

    // ⁦…⁩ = left-to-right isolate, so "4-5" doesn't flip to "5-4" in Hebrew
    const L = (t) => '⁦' + t + '⁩';
    // size value → [age label, shoe size]. The size is the real Shopify variant; age is only a label for parents
    const AGES = [['1', '3', '26-28'], ['2', '4-5', '29-30'], ['3', '6-7', '31-33'], ['4', '8-10', '34-36'], ['5', '11-12', '37-38']];
    let byAge = false;
    const sizeOf = (v) => AGES.find((x) => x[0] === v)[2];
    const sizeText = (v, by) => { const a = AGES.find((x) => x[0] === v); return by === 'age' ? 'גיל ' + L(a[1]) : 'מידה ' + L(a[2]); };
    const COLORS = [{ name: 'כחול', hex: '#71A9D5' }, { name: 'ורוד', hex: '#F3A9C1' }];
    const hexOf = (name) => (COLORS.find((c) => c.name === name) || {}).hex;
    const SINGLE = +root.querySelector('.pack').dataset.total;
    // each pack keeps its own picks: an unfilled pack opens empty, returning restores its picks
    const packState = new Map();
    let picks = [];
    let activePack = root.querySelector('.pack.is-active');
    let seen = 1, open = 0, needIdx = -1, lastOpen = -1, advTimer = null;
    const done = (p) => !!(p.color && p.val);
    const nPairs = () => +activePack.dataset.pairs;
    const isGift = (i) => i >= Math.round(+activePack.dataset.total / SINGLE);
    const GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/></svg>';
    const giftTag = () => `<span class="gift">${GIFT}מתנה</span>`;

    function editorHTML(i, n) {
      const pk = picks[i], cls = 'pedit' + (n === 1 ? ' solo' : '') + (i === needIdx ? ' need' : '') + (n > 1 && i !== lastOpen ? ' new' : '');
      return `<div class="${cls}" data-i="${i}">` +
        (n > 1 ? `<div class="phead"><b>זוג ${i + 1}</b>${isGift(i) ? giftTag() : ''}</div>` : '') +
        `<div class="prow2"><span class="plbl">צבע</span><span class="dots">` +
        COLORS.map((c) => `<button type="button" class="dot${pk.color === c.name ? ' is-on' : ''}" data-color="${c.name}" aria-label="${c.name}" style="background:${c.hex}"></button>`).join('') +
        `</span></div>` +
        `<div class="prow2"><span class="plbl">${byAge ? 'גיל' : 'מידה'}</span><span class="ages">` +
        AGES.map(([v, t, s]) => `<button type="button" class="age${pk.val === v ? ' is-on' : ''}" data-v="${v}" aria-label="מידה ${s}, בערך גיל ${t}">${L(byAge ? t : s)}</button>`).join('') +
        `</span></div></div>`;
    }
    function summaryHTML(i) {
      const pk = picks[i];
      return `<div class="psum${done(pk) ? '' : ' miss'}" data-i="${i}" role="button" tabindex="0">` +
        `<span class="sdot" style="background:${hexOf(pk.color) || '#E3E3E3'}"></span>` +
        `<span class="stxt"><b>זוג ${i + 1}</b>${isGift(i) ? ' ' + giftTag() : ''}<i class="sep">·</i>${pk.color || 'חסר צבע'}<i class="sep">·</i>${pk.val ? sizeText(pk.val, pk.by) : 'חסר מידה'}</span>` +
        `<span class="edit">שינוי</span></div>`;
    }
    function renderPairs() {
      const n = nPairs(), box = activePack.querySelector('.pairs');
      root.querySelectorAll('.pairs').forEach((b) => { if (b !== box) b.innerHTML = ''; });
      // a pair reopened with "שינוי" returns to the mode it was picked in
      if (open !== lastOpen) byAge = open >= 0 && picks[open]?.by === 'age';
      let h = '';
      if (n > 1) {
        h += `<div class="ptop"><span class="pstep">${open >= 0 ? `זוג ${open + 1} מתוך ${n}` : `כל ${n} הזוגות נבחרו ✓`}</span><span class="pdots">` +
          picks.slice(0, n).map((p, i) => `<i class="${done(p) ? 'ok' : ''}${i === open ? ' cur' : ''}"></i>`).join('') + `</span></div>`;
      }
      for (let i = 0; i < seen; i++) h += (i === open || n === 1) ? editorHTML(i, n) : summaryHTML(i);
      if (open >= 0 || n === 1) h += `<p class="pnote">` + (byAge
        ? `הגילאים לפי ילד ממוצע. גדול או קטן לגילו? בחרו בהתאם.<br><button type="button" class="plink">בחירה לפי מידת נעל</button>`
        : `לא בטוחים בין שתי מידות? בחרו את הגדולה ותגזרו בבית.<br>לא יודעים איזה מידה? <button type="button" class="plink">בחרו לפי הגיל</button>`) + `</p>`;
      box.innerHTML = h;
      box.querySelector('.plink')?.addEventListener('click', (e) => { e.stopPropagation(); byAge = !byAge; renderPairs(); });
      lastOpen = open;
      Object.assign(packState.get(activePack), { seen, open });
      box.querySelectorAll('.pedit').forEach((ed) => {
        const i = +ed.dataset.i;
        ed.querySelectorAll('.dot').forEach((d) => d.addEventListener('click', () => pick(i, 'color', d.dataset.color)));
        ed.querySelectorAll('.age').forEach((b) => b.addEventListener('click', () => pick(i, 'val', b.dataset.v)));
      });
      box.querySelectorAll('.psum').forEach((s) => s.addEventListener('click', () => { clearTimeout(advTimer); open = +s.dataset.i; needIdx = -1; renderPairs(); }));
      updateATC();
    }
    // a completed pair folds into a summary after a short beat, and the next missing pair opens
    function pick(i, key, val) {
      if (key) picks[i][key] = val;
      if (key === 'val') picks[i].by = byAge ? 'age' : 'size';
      if (i === needIdx) needIdx = -1;
      err.textContent = '';
      renderPairs();
      const n = nPairs();
      clearTimeout(advTimer);
      if (n > 1 && i === open && done(picks[i])) advTimer = setTimeout(() => { if (open !== i) return; nextOpen(); renderPairs(); }, 300);
    }
    function nextOpen() {
      const m = picks.slice(0, seen).findIndex((p) => !done(p));
      if (m !== -1) open = m; else if (seen < nPairs()) { seen++; open = seen - 1; } else open = -1;
    }
    function buildPairs() {
      const n = nPairs();
      clearTimeout(advTimer); needIdx = -1; lastOpen = -1;
      if (!packState.has(activePack)) packState.set(activePack, { picks: Array.from({ length: n }, () => ({ color: null, val: null })), seen: 1, open: 0 });
      ({ picks, seen, open } = packState.get(activePack));
      if (n > 1 && open >= 0 && done(picks[open])) nextOpen();
      renderPairs();
    }
    const missing = () => picks.slice(0, nPairs()).findIndex((p) => !done(p));
    function updateATC() {
      const n = nPairs(), i = missing(), ok = i === -1;
      atc.classList.toggle('locked', !ok); atc.setAttribute('aria-disabled', String(!ok));
      if (ok) { atc.textContent = '₪' + activePack.dataset.total + ' – הוספה לסל'; return; }
      const p = picks[i], left = picks.slice(0, n).filter((q) => !done(q)).length, z = n > 1 ? ` לזוג ${i + 1}` : '';
      if (p.color && !p.val) atc.textContent = 'חסר מידה' + z;
      else if (!p.color && p.val) atc.textContent = 'חסר צבע' + z;
      else if (n === 1) atc.textContent = 'בחרו צבע ומידה';
      else atc.textContent = left > 1 ? `נשארו ${left} זוגות לבחירה` : 'נשאר עוד זוג אחד לבחירה';
    }

    // add to cart: one line per colour+size variant with its quantity, nothing else on the line
    async function addToCart() {
      const qty = new Map();
      for (const p of picks.slice(0, nPairs())) {
        const v = variants[p.color + '|' + sizeOf(p.val)];
        if (!v) { err.textContent = 'משהו השתבש, נסו לרענן את הדף'; return; }
        qty.set(v.id, (qty.get(v.id) || 0) + 1);
      }
      const cartDrawer = document.querySelector('cart-drawer');
      const body = { items: [...qty].map(([id, quantity]) => ({ id, quantity })) };
      if (cartDrawer) { body.sections = cartDrawer.getSectionsToRender().map((s) => s.id); body.sections_url = window.location.pathname; }
      atc.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body),
        });
        const data = await res.json();
        if (!res.ok || data.status) { err.textContent = data.description || data.message || 'לא הצלחנו להוסיף לסל, נסו שוב'; return; }
        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(data);
        } else {
          window.location.href = window.routes?.cart_url || '/cart';
        }
      } catch (e) {
        err.textContent = 'לא הצלחנו להוסיף לסל, נסו שוב';
      } finally {
        atc.removeAttribute('aria-busy');
      }
    }
    atc.addEventListener('click', () => {
      const i = missing();
      if (i === -1) { addToCart(); return; }
      clearTimeout(advTimer);
      if (nPairs() > 1) { while (seen <= i) seen++; open = i; }
      needIdx = i; renderPairs();
      activePack.querySelector('.pedit.need')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    function selectPack(p) {
      if (p === activePack) return;   // clicks inside the selected pack never reset it
      root.querySelectorAll('.pack').forEach((x) => { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
      p.classList.add('is-active'); p.setAttribute('aria-checked', 'true'); activePack = p;
      const st = states[+p.dataset.step];
      tier.style.setProperty('--fill', st.fill);
      tier.classList.toggle('done', st.done);
      root.querySelector('[data-tier-msg]').innerHTML = st.msg;
      tier.querySelectorAll('.t').forEach((t, i) => t.classList.toggle('on', i < st.on));
      err.textContent = '';
      buildPairs();
    }
    root.querySelectorAll('.pack').forEach((p) => {
      p.addEventListener('click', () => selectPack(p));
      p.addEventListener('keydown', (e) => { if ((e.key === 'Enter' || e.key === ' ') && e.target === p) { e.preventDefault(); selectPack(p); } });
    });
    buildPairs();
  }

  // ===== customer videos: tap opens a full-screen player with sound =====
  function initUgc(root) {
    const cards = [...root.querySelectorAll('.ugc-card')];
    const modal = root.querySelector('.vmodal'), player = modal.querySelector('video'), count = modal.querySelector('.count');
    // fixed overlay must not sit inside a transformed parent; keep it in an .rf wrapper for the styles
    const holder = document.createElement('div'); holder.className = 'rf';
    holder.appendChild(modal); document.body.appendChild(holder);
    let idx = 0;
    function openVideo(i) {
      idx = (i + cards.length) % cards.length;
      player.src = cards[idx].dataset.src; player.muted = false;
      count.textContent = (idx + 1) + ' / ' + cards.length;
      modal.classList.add('open'); modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      player.play().catch(() => {});
    }
    function closeVideo() {
      player.pause(); player.removeAttribute('src'); player.load();
      modal.classList.remove('open'); modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    cards.forEach((c, i) => c.addEventListener('click', () => openVideo(i)));
    modal.querySelector('[data-v-close]').addEventListener('click', closeVideo);
    modal.querySelector('[data-v-next]').addEventListener('click', () => openVideo(idx + 1));
    modal.querySelector('[data-v-prev]').addEventListener('click', () => openVideo(idx - 1));
    modal.addEventListener('click', (e) => { if (e.target === modal) closeVideo(); });
    document.addEventListener('keydown', (e) => {
      if (!modal.classList.contains('open')) return;
      if (e.key === 'Escape') closeVideo(); if (e.key === 'ArrowLeft') openVideo(idx + 1); if (e.key === 'ArrowRight') openVideo(idx - 1);
    });
    let tx = null;
    modal.addEventListener('touchstart', (e) => { tx = e.touches[0].clientX; }, { passive: true });
    modal.addEventListener('touchend', (e) => {
      if (tx === null) return; const dx = e.changedTouches[0].clientX - tx; tx = null;
      if (Math.abs(dx) > 50) openVideo(idx + (dx > 0 ? 1 : -1));
    });
  }

  // ===== how it works: one step at a time, the next peeks in =====
  function initHow(root) {
    const track = root.querySelector('.how-track');
    const steps = [...track.children], dots = [...root.querySelector('.how-dots').children];
    if (!steps.length) return;
    let cur = 0;
    const st = {};
    const posOf = (i) => steps[i].offsetLeft - steps[0].offsetLeft;
    const stepW = () => (steps[1] ? Math.abs(steps[0].offsetLeft - steps[1].offsetLeft) : track.clientWidth);
    function activate(i) {
      if (i === cur && steps[i].classList.contains('on')) return;
      cur = i;
      steps.forEach((s, k) => {
        s.classList.toggle('on', k === i); const v = s.querySelector('video'); if (!v) return;
        if (k === i) { v.muted = true; v.play().catch(() => {}); } else v.pause();
      });
      dots.forEach((d, k) => d.classList.toggle('on', k === i));
    }
    function go(i) { i = Math.max(0, Math.min(steps.length - 1, i)); activate(i); scrollToX(track, posOf(i), 380, st); }
    track.addEventListener('scroll', () => { if (st.anim) return; activate(Math.max(0, Math.min(steps.length - 1, Math.round(Math.abs(track.scrollLeft) / stepW())))); }, { passive: true });
    steps.forEach((s, i) => s.addEventListener('click', () => { if (i !== cur) go(i); }));
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
    mouseDrag(track, (dx) => { if (Math.abs(dx) > 40) go(cur + (dx > 0 ? 1 : -1)); else go(cur); });
    new IntersectionObserver((es) => es.forEach((e) => {
      const v = steps[cur].querySelector('video'); if (!v) return;
      if (e.isIntersecting) { v.muted = true; v.play().catch(() => {}); } else v.pause();
    }), { threshold: 0.3 }).observe(track);
    steps[0].classList.remove('on'); activate(0);
  }

  // ===== setup: iPhone / Android toggle + swipe =====
  function initSetup(root) {
    const tabs = [...root.querySelectorAll('.os-tabs button')];
    const lists = [...root.querySelectorAll('.setup-track')];
    tabs.forEach((t) => t.addEventListener('click', () => {
      tabs.forEach((x) => x.classList.toggle('on', x === t));
      lists.forEach((l) => { const show = l.dataset.os === t.dataset.os; l.hidden = !show; if (show) l.scrollLeft = 0; });
    }));
    lists.forEach((track) => mouseDrag(track));
  }

  // ===== FAQ: open/close + "עוד שאלות" =====
  function initFaq(root) {
    root.querySelectorAll('.faq-q').forEach((b) => b.addEventListener('click', () => b.parentElement.classList.toggle('open')));
    root.querySelector('.faq-more')?.addEventListener('click', (e) => {
      root.querySelectorAll('.faq-item[hidden]').forEach((i) => { i.hidden = false; });
      e.currentTarget.remove();
    });
  }

  const INITS = { 'data-rf-product': initProduct, 'data-rf-ugc': initUgc, 'data-rf-how': initHow, 'data-rf-setup': initSetup, 'data-rf-faq': initFaq };
  function initAll(scope) {
    for (const [attr, fn] of Object.entries(INITS)) {
      scope.querySelectorAll(`[${attr}]`).forEach((el) => {
        if (el.__rf) return; el.__rf = true;
        try { fn(el); } catch (e) { console.error('RunFree', attr, e); }
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document)); else initAll(document);
  // theme editor: re-init a section after it is re-rendered
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
